<template>
  <div>
    <loader :isLoading="isAgreementsRequestInProgress"/>

    <CreateNavBar/>

    <div class="container view-agreement" v-if="Object.keys(agreementData).length !== 0">
      <p class="agreement-mini-header text-right">Agreement</p>
      <h3 v-if="agreementData.other_agreement_name !== 'none'">
        {{ agreementData.other_agreement_name }}
      </h3>
      <h3 v-else>
        {{ agreementData.agreement_name }}
      </h3>
      <p>{{ agreementData.company_name }}</p>
      <div v-html="agreementData.content"></div>
    </div>

    <div class="text-center">
      <small data-type="message" class="form-text error-message" v-if="fetchAgreementsError">
        {{ fetchAgreementsError }}
      </small>
    </div>

    <Footer/>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { FETCH_AGREEMENT_BY_REF } from '@/store/types/actions.type'

import CreateNavBar from '@/components/common/CreateNavBar'
import Footer from '@/components/common/Footer'
import Loader from '@/components/common/Loader'

import { AuthService } from '@/api/AuthService'

const auth = new AuthService()

export default {
  components: {
    CreateNavBar,
    Footer,
    Loader
  },
  data() {
    return {
      agreementId: '',
      ownerId: '',
      userId: '',
      agreementData: {}
    }
  },
  computed: {
    ...mapGetters([
      'fetchAgreementsError',
      'isAgreementsRequestInProgress'
    ])
  },
  mounted() {
    this.agreementId = this.$route.params.agid
    this.ownerId = this.$route.params.uid
    this.userId = auth.getUserId()

    // console.log('agreementsid: ', this.agreementId)
    // console.log('ownerid: ', this.ownerId)
    // console.log('userID: ', this.userId)

    this.getAgreementsByID()
  },
  methods: {
    // TODO: add checking if loggedInUser have passInvite to access agreements
    getAgreementsByID() {
      var self = this
      this.$store.dispatch(FETCH_AGREEMENT_BY_REF, this.agreementId)
      .then(data => {
        if(data.type === 'link') {
          window.location = data.link
        } else {
          self.agreementData = data
        }
      })
    }
  }
}

</script>

<style scoped>

.view-agreement {
  margin-top: 30px;
  margin-bottom: 30px;
  padding: 30px;
  min-height: 400px;
  background-color: #F2F9FF;
  width: 85%;
}

.agreement-mini-header {
  font-style: italic;
}

/deep/ p br {
  display: none;
}

/deep/ h2 {
  font-size: 25px;
  margin-top: 30px;
}

/deep/ p {
  font-weight: 400;
}

</style>



// WEBPACK FOOTER //
// src/containers/agreements/ViewAgreements.vue